export const MAX_HOST_TRACKS = 100

export interface HostAccount {
  _id?: string
  fullName: string
  username: string
  password: string
  photoUrl?: string
  active: boolean
  createdAt?: string
  updatedAt?: string
}

export type MessageStatus = 'pending' | 'approved' | 'rejected'

export interface HostMessage {
  _id?: string
  hostId: string
  hostName: string
  senderName: string
  phone: string
  city: string
  message: string
  read: boolean
  status?: MessageStatus
  createdAt?: string
}

export interface HostTrack {
  _id?: string
  hostId: string
  title: string
  artist?: string
  fileUrl: string
  fileName?: string
  sizeBytes?: number
  order: number
  createdAt?: string
}
